import { API_URL } from "./api";

const helpAssistantService = {
  /**
   * Stream a help assistant reply (plain-text body).
   * @param {{ messages: Array<{role, content}> }} payload
   * @param {AbortSignal} [signal]
   */
  streamChat(payload, signal) {
    return fetch(`${API_URL}/help-assistant`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify(payload),
      signal,
    });
  },
};

export default helpAssistantService;
